export default "__VITE_ASSET__bb7f682a__"